import { render, staticRenderFns } from "./ViewTemplatesPdfDrawing.vue?vue&type=template&id=72eb5c6a"
import script from "./ViewTemplatesPdfDrawing.vue?vue&type=script&lang=js"
export * from "./ViewTemplatesPdfDrawing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports